
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {
mapState,
mapActions
} from 'vuex'
import rsBottom from 'components/home/rs_bottom'
import * as types from './vuex/types'
import {
directRightUrl
} from './util'

export default {
name: 'app',
directives: {
TransferDom
},
components: {
Loading,
rsBottom
},
data() {
return {
includedComponents: 'home,discover'
}
},
computed: {
...mapState({
loading: state => state.common.loading,
direction: state => state.common.direction,
showBottom: state => state.common.showBottom,
})
},
methods: {
...mapActions([
'getUserInfo'
])
},
mounted() {
directRightUrl()
this.getUserInfo()
}
}



// WEBPACK FOOTER //
// ./src/App.vue